import React, { PureComponent } from "react";
import Page from "../Page";
import * as config from "../../config";

export default class ErrorPage extends PureComponent {
    componentDidMount = () => {
    }
    
    render() {
        return (
            <Page showHeader={true} title="Error">
                <div className="row mt-3 text-center">
                    <div className="col">            
                        <div className="warning-box p-3 mt-4 text-bold">                    
                             <p>An error has occurred on the site, and AANP has been alerted of the issue.&nbsp;&nbsp;Please return to the <a href={config.rootUrl}>home page</a> or try again later.</p>
                        </div>            
                    </div>
                </div>                                
            </Page>
        );
    }
}